const landingUrl = 'https://www.getamplifylife.com/';

export default landingUrl;
